import { Controller } from "@hotwired/stimulus"

// Toggles visibility of credits_per_hour vs credits_per_visit and the special rate periods card based on charging_type select.
export default class extends Controller {
  static targets = ["creditsPerHourGroup", "creditsPerVisitGroup", "periodsCard"]

  connect() {
    this.toggle()
  }

  toggleCreditsPerVisit() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector('select[name*="[charging_type]"]')
    if (!select) return

    const value = select.value
    const hidePerHour = value === "credits_per_visit" || value === "no_charge"
    const showPerVisit = value === "credits_per_visit"

    if (this.hasCreditsPerHourGroupTarget) {
      this.creditsPerHourGroupTargets.forEach((el) => {
        el.classList.toggle("hidden", hidePerHour)
        const input = el.querySelector('input[type="number"]')
        if (input) {
          if (hidePerHour && this.hasPeriodsCardTarget && this.periodsCardTarget.contains(el)) input.value = "0"
          input.required = !hidePerHour
        }
      })
    }
    if (this.hasCreditsPerVisitGroupTarget) {
      this.creditsPerVisitGroupTargets.forEach((el) => {
        el.classList.toggle("hidden", !showPerVisit)
        const input = el.querySelector('input[type="number"]')
        if (input) input.required = showPerVisit
      })
    }
    if (this.hasPeriodsCardTarget) {
      this.periodsCardTarget.classList.toggle("hidden", value === "no_charge")
    }
  }
}
